import * as React from 'react';
import styled from 'styled-components';
import { ICarouselNavigationProps } from '../navigation';
import { selectThemeSemantics } from '../../../../../../styling';
import { FlexBox } from '../../../../../flex-box';

interface IDotsProps extends Pick<ICarouselNavigationProps, 'itemsIterator' | 'activeKey' | 'isHorizontal' | 'className' | 'indicatorPosition'> {
}

interface IDotProps {
    active: boolean;
    className: string;
    id: React.Key;
    onChange(key: React.Key): void;
}

const DotBase = React.memo((props: IDotProps) => {
    const { onChange, id, className } = props;

    const _onClick = React.useCallback(() => {
        if (onChange) {
            onChange(id);
        }
    }, [id, onChange]);

    return <div className={className} onClick={_onClick} key={id} />;
});

DotBase.displayName = 'Dot';

export const Dot = styled(DotBase).attrs(() => ({
    className: String('ap-navigation-dot')
}))`
    border-width: ${({ theme: { carousel: { composites } } }) => composites.dotsNavigationBorderWidth};
    border-style: solid;
    border-color: ${({ theme: { carousel: { colors } } }) => colors.dotsNavigationBorderColor};
    border-radius: ${({ theme: { carousel: { composites } } }) => composites.dotsNavigationBorderRadius};
    margin: ${selectThemeSemantics(({ gap }) => gap.m)};
    cursor: pointer;
    background-color: ${({ active, theme: { carousel: { colors } } }) => (active ? colors.dotsNavigationBackgroundColorOnActive : colors.dotsNavigationBackgroundColor)};
    height: 10px;
    width: 10px;
    display: inline-block;
    justify-content: center;
    position: relative;
    pointer-events: ${({ active }) => (active ? 'none' : 'default')};
`;

class DotsBase extends React.PureComponent<IDotsProps> {

    render() {
        const { itemsIterator, className, isHorizontal } = this.props;
        return (
            <FlexBox justifyContent="center" flexDirection={isHorizontal ? 'row' : 'column'} className={className}>
                {itemsIterator.getAllValues().map(this.renderDot)}
            </FlexBox>
        );
    }

    private renderDot = (key: React.Key) => {
        const { activeKey } = this.props;
        return (
            <Dot
                key={key}
                id={key}
                active={key === activeKey}
                onChange={this._onChange}
            />
        );
    }

    private _onChange = (activeKey: React.Key) => {
        const { itemsIterator } = this.props;
        itemsIterator.find(key => key === activeKey);
    }
}

export const Dots = styled(DotsBase) <IDotsProps>`
        position: absolute;
        background-color: ${({ theme: { carousel: { colors } } }) => colors.dotsNavigationPanelBackgroundColor};
        width: ${({ isHorizontal }) => (!isHorizontal ? '24px' : '100%')};
        height: ${({ isHorizontal }) => (isHorizontal ? '24px' : '100%')};
        bottom: 0;
        right: ${({ isHorizontal, indicatorPosition }) => (indicatorPosition === 'right' && isHorizontal ? 'unset' : '0px')};
        left: ${({ isHorizontal, indicatorPosition }) => (indicatorPosition === 'left' && !isHorizontal ? '0px' : 'unset')};
        visibility: visible;
`;
